'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LinkageSelect = require('../components/LinkageSelect');

var _LinkageSelect2 = _interopRequireDefault(_LinkageSelect);

var _util = require('../components/LinkageSelect/util');

var _Base2 = require('./Base');

var _Base3 = _interopRequireDefault(_Base2);

var _utils = require('./utils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Card = (_temp = _class = function (_Base) {
  _inherits(Card, _Base);

  function Card(props) {
    _classCallCheck(this, Card);

    var _this = _possibleConstructorReturn(this, _Base.call(this, props));

    _this.state = _extends({}, _this.state, {
      fieldSelectedStatus: false, // 表单项选择模式开启关闭状态
      fieldSelectedChecked: false // 表单项选择模式选项选中状态
    });

    _this.fieldCheckboxOnChange = _this.fieldCheckboxOnChange.bind(_this);
    _this.handleShareAdd = _this.handleShareAdd.bind(_this);
    return _this;
  }

  Card.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    _Base.prototype.componentDidMount.call(this);

    // 更新表单项选择模式数据
    if (this.props.context && !this.props.disableFieldSelect) {
      var fieldsSelectModeStatus = this.props.context.getGlobal('fieldsSelectModeStatus') || false;
      var fieldsSelectModeData = this.props.context.getGlobal('fieldsSelectModeData') || [];
      this.setState({
        fieldSelectedStatus: fieldsSelectModeStatus,
        fieldSelectedChecked: fieldsSelectModeData.findIndex(function (i) {
          return i && i.fieldId === _this2.props.fieldId;
        }) >= 0
      });
    }
  };

  Card.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var flag = _Base.prototype.shouldComponentUpdate.call(this, nextProps, nextState);
    if (nextProps.context && !nextProps.disableFieldSelect) {
      var fieldsSelectModeStatus = nextProps.context.getGlobal('fieldsSelectModeStatus') || false;
      var fieldsSelectModeData = nextProps.context.getGlobal('fieldsSelectModeData') || [];
      var checked = fieldsSelectModeData.findIndex(function (i) {
        return i && i.fieldId === nextProps.fieldId;
      }) >= 0;

      // 判断是否更新
      if (this.state.fieldSelectedStatus !== fieldsSelectModeStatus || this.state.fieldSelectedChecked !== checked) {
        flag = true;
      }
    }

    return flag;
  };

  // 获取是否渲染表单项选择模式状态


  Card.prototype.getFieldSelectedRenderFlag = function getFieldSelectedRenderFlag() {
    // 若在vision引擎中或选择模式未开启或本身表单项是隐藏的，则不渲染表单项选择模式
    return !window.VisualEngine && !this.props.disableFieldSelect && this.props.isInDetail && this.state.fieldSelectedStatus && this.props.visible;
  };

  // 获取是否展示补齐补正信息渲染状态


  Card.prototype.getSupplementRenderFlag = function getSupplementRenderFlag() {
    // C端沿用correctionTip字段，在field 错误区域展示，不用单独去渲染，办件详情中需要单独去取渲染
    return !window.VisualEngine && !this.props.disableFieldSelect && this.props.isInDetail && this.props.correctionIconMessage;
  };

  Card.prototype.getFieldValue = function getFieldValue() {
    var $state = this.props.$state;

    return $state && $state.getVal();
  };

  Card.prototype.handleAdd = function handleAdd(rows, item) {
    if (this.isMeetMax(rows.length)) {
      return false;
    }
    return _Base.prototype.handleAdd.call(this, rows, item);
  };

  Card.prototype.handleShareAdd = function handleShareAdd(item) {
    var rows = this.getValue();
    if (this.isMeetMax(rows.length)) {
      return false;
    }
    return _Base.prototype.handleShareAdd.call(this, rows, item);
  };

  // form field checkbox 选中变化handler


  Card.prototype.fieldCheckboxOnChange = function fieldCheckboxOnChange(checked, e) {
    // 更新当前表单项选择模式状态
    this.setState({ fieldSelectedChecked: checked });

    // 读取全局状态中表单选项模式数据
    var fieldsSelectModeData = (0, _lodash.cloneDeep)(this.props.context.getGlobal('fieldsSelectModeData') || []);

    var _props = this.props,
        componentName = _props.componentName,
        label = _props.label,
        fieldId = _props.fieldId;

    // 更丰富的数据给应用层使用

    var newData = {
      componentName: componentName,
      label: label,
      fieldId: fieldId,
      value: '--' // 卡片组件选择模式时，不对子组件做取值
    };

    var idx = fieldsSelectModeData.findIndex(function (i) {
      return i && i.fieldId === fieldId;
    });
    if (checked) {
      // 若存在重复的fieldId则替换，否则追加数据
      if (idx >= 0) {
        fieldsSelectModeData.splice(idx, 1, newData);
      } else {
        fieldsSelectModeData.push(newData);
      }
    } else {
      // 取消选中，剔除对应已选中的fieldId数据
      if (idx >= 0) {
        fieldsSelectModeData.splice(idx, 1);
      }
    }

    // 更新全局状态中表单选项模式数据
    this.props.context.setGlobal({ fieldsSelectModeData: fieldsSelectModeData });

    typeof this.props.onFieldsSelectChange === 'function' && this.props.onFieldsSelectChange({
      checked: checked,
      currentData: newData || {},
      selectedData: [].concat(_toConsumableArray(fieldsSelectModeData))
    });
  };

  Card.prototype.renderErrorMsg = function renderErrorMsg() {
    var _props2 = this.props,
        hasError = _props2.hasError,
        errorMsg = _props2.errorMsg,
        correctionTip = _props2.correctionTip;

    if (!hasError && (0, _lodash.isEmpty)(correctionTip)) {
      return null;
    }
    return _react2.default.createElement(
      'div',
      { className: 'vc-card-error-msg' },
      errorMsg || correctionTip
    );
  };

  // 渲染补齐补正信息


  Card.prototype.renderSupplement = function renderSupplement() {
    if (!this.getSupplementRenderFlag()) {
      return null;
    }

    var _props3 = this.props,
        correctionTip = _props3.correctionTip,
        correctionIconMessage = _props3.correctionIconMessage,
        isInDetail = _props3.isInDetail;


    return _react2.default.createElement(
      'span',
      {
        className: (0, _classnames2.default)('item-field-supplement', {
          'item-field-supplement-icon': isInDetail
        })
      },
      isInDetail ? correctionIconMessage : correctionTip
    );
  };

  // 当开启fieldSelect模式时，渲染表单每一项前面的checkbox


  Card.prototype.renderFieldCheckbox = function renderFieldCheckbox() {
    if (!this.getFieldSelectedRenderFlag()) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: 'item-field-select-wrap' },
      _react2.default.createElement(_next.Checkbox, {
        className: 'item-field-select-checkbox',
        checked: this.state.fieldSelectedChecked || false,
        onChange: this.fieldCheckboxOnChange
      })
    );
  };

  Card.prototype.render = function render() {
    var _this3 = this;

    var _props4 = this.props,
        componentId = _props4.componentId,
        children = _props4.children,
        className = _props4.className,
        fieldId = _props4.fieldId,
        showLabel = _props4.showLabel,
        _props4$linkageShareD = _props4.linkageShareData,
        linkageShareData = _props4$linkageShareD === undefined ? {} : _props4$linkageShareD;

    var status = this.getStatus();
    var rowsData = this.getValue();
    var iteratorIdPrefix = this.props.__iteratorId || componentId;
    var showLinkageShareBtn = (0, _util.showLinkageShare)(linkageShareData);
    var trueLabel = (0, _utils.handleRenderLabel)(this.props);
    var rows = rowsData && rowsData.map ? rowsData.map(function (item, index) {
      var childElem = void 0;
      var __iteratorId = iteratorIdPrefix + '-' + item.getId();
      if (status !== 'NORMAL' && (0, _lodash.isEmpty)(item.getData())) {
        childElem = _react2.default.createElement(
          'div',
          { className: 'vc-empty' },
          '\u5217\u8868\u6570\u636E\u4E3A\u7A7A'
        );
      } else {
        var __ownerScope = item;
        var passThrough = {
          scope: item.getValue()
        };
        item.setUseSelfDefaultValue(item.getValue('__mergeAfterBind') !== false);
        childElem = children ? children.map(function (child) {
          var __passThrough = _extends({}, child.props.__passThrough, passThrough);
          return _react2.default.cloneElement(child, {
            __passThrough: __passThrough,
            __ownerScope: __ownerScope,
            __iteratorId: __iteratorId,
            __index: index,
            disableFieldSelect: true, // 卡片禁用子组件的表单项选择模式，服务端不支持
            enableInputBalloon: false, // 禁止Input子组件开启气泡提示
            isChildComponent: true,
            // 为卡片子组件新注册onBlur事件，特殊用于触发异步脱敏请求
            onBlur: function onBlur(_ref) {
              var _ref$componentProps = _ref.componentProps,
                  componentProps = _ref$componentProps === undefined ? {} : _ref$componentProps;

              try {
                // 获取当前子组件所在行最新值
                var value = (__ctx__.getFieldDataById(_this3.props.fieldId) || {}).value || [];

                // 触发事件，只有配置了特殊应子组件onBlur事件才会触发
                var event = __ctx__.globalEvents[_this3.props.fieldId] && __ctx__.globalEvents[_this3.props.fieldId]['onCardSubBlur_' + componentProps.fieldId] && __ctx__.globalEvents[_this3.props.fieldId]['onCardSubBlur_' + componentProps.fieldId][0];
                event && event(undefined, {
                  cardSubBlurEvt: true,
                  cardFieldId: _this3.props.fieldId,
                  cardCurRowData: value[index] || {},
                  cardChangedKey: {
                    subId: child.props.id,
                    rowIndex: index,
                    CHANGED: Math.random()
                  },
                  cardRowIndex: index
                });
              } catch (err) {
                console.log('error', err);
              }
            }
          });
        }) : [];
      }

      // 保证外部数据格式变了之后重新渲染
      var key = __iteratorId;

      // 明细组件title定制渲染标题
      var num = index === 0 && rowsData.length <= 1 ? '' : index + 1;

      return _react2.default.createElement(
        'div',
        { key: key },
        _react2.default.createElement(
          'div',
          { className: 'vc-card-title' },
          _react2.default.createElement(
            'label',
            null,
            showLabel ? (0, _utils.handleRenderLabel)(_this3.props, num) : ''
          ),
          rowsData.length > _this3.minRows && status === 'NORMAL' ? _react2.default.createElement(
            'span',
            { className: 'vc-card-delete', onClick: function onClick() {
                return _this3.handleDelete(item, index);
              } },
            _this3.props.deleteButtonName
          ) : null
        ),
        childElem
      );
    }) : null;

    var mainRenderContent = _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)('vc-card', className, { 'vc-form-item-hidden': status === 'HIDDEN' }),
        'data-field-id': fieldId
      },
      rowsData.length === 0 ? _react2.default.createElement(
        'div',
        { className: 'vc-card-title' },
        _react2.default.createElement(
          'label',
          { required: this.getRequired() },
          showLabel ? trueLabel : ''
        )
      ) : null,
      rows,
      !this.judgeMinEqualsMax() && status === 'NORMAL' ? _react2.default.createElement(
        'div',
        { className: 'vc-card-addons' },
        showLinkageShareBtn ? _react2.default.createElement(_LinkageSelect2.default, { superProps: _extends({}, this.props), disabled: this.isMeetMax(rowsData.length),
          handleAdd: this.handleShareAdd
        }) : null,
        _react2.default.createElement(
          _next.Button,
          {
            type: 'secondary',
            disabled: this.isMeetMax(rowsData.length),
            onClick: function onClick() {
              _this3.handleAdd(rowsData, {});
            }
          },
          _react2.default.createElement(_next.Icon, { type: 'add' }),
          this.props.buttonName
        ),
        this.props.listNum ? _react2.default.createElement(
          'span',
          { className: 'vc-card-maxMsg' },
          '(\u6700\u591A\u6DFB\u52A0' + this.props.listNum + '\u6761)'
        ) : null
      ) : null,
      this.renderErrorMsg()
    );

    return _react2.default.createElement(
      'div',
      { className: 'vc-form-item-container' },
      this.renderFieldCheckbox(),
      mainRenderContent,
      this.renderSupplement()
    );
  };

  return Card;
}(_Base3.default), _class.mutableStates = _Base3.default.mutableStates, _class.defaultProps = _extends({}, _Base3.default.defaultProps, {
  showLabel: false,
  buttonName: '新增一条',
  deleteButtonName: '删除'
}), _temp);
exports.default = Card;
module.exports = exports['default'];